import { useEffect } from "react";

/**
 * Inserts <meta name="robots" content="noindex, nofollow"> into <head> while
 * the calling page is mounted, and removes it on unmount. Used on transient
 * funnel pages so crawlers don't index private results / capture URLs.
 */
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow");
    meta.setAttribute("data-source", "noindex-hook");
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);
}
